const collections = [
  {
    label: "Solar Generators",
    description: "EcoFlow, Nature's Generator, Renogy — portable and expandable solar power stations with manufacturer warranties.",
    icon: "ri-sun-line",
    iconBg: "bg-amber-100",
    iconColor: "text-amber-600",
    href: "https://ironhavensupply.com/collections/solar-generators",
    badge: "Most Popular",
    badgeColor: "bg-amber-500",
  },
  {
    label: "Home Backup Power",
    description: "Whole-home and partial-home backup systems for families who can't afford to lose power.",
    icon: "ri-home-wifi-line",
    iconBg: "bg-slate-100",
    iconColor: "text-slate-600",
    href: "https://ironhavensupply.com/collections/home-backup-power",
    badge: "Complete Coverage",
    badgeColor: "bg-slate-600",
  },
  {
    label: "Off-Grid Systems",
    description: "Full off-grid power kits for cabins, tiny homes, and remote properties.",
    icon: "ri-tree-line",
    iconBg: "bg-emerald-50",
    iconColor: "text-emerald-600",
    href: "https://ironhavensupply.com/collections/off-grid-power-systems",
    badge: "Energy Independence",
    badgeColor: "bg-emerald-600",
  },
];

export default function ComparisonCTA() {
  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-amber-400 text-xs font-bold uppercase tracking-widest">Shop Now</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mt-2 mb-3">
            Ready to Stop Guessing and Start Powering?
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            Iron Haven Supply is an authorized U.S. dealer. Every product ships with full manufacturer warranty. Real humans answer the phone.
          </p>
        </div>

        {/* Collection cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {collections.map((c) => (
            <a
              key={c.label}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gray-800 hover:bg-gray-750 border border-gray-700 hover:border-amber-500/50 rounded-2xl p-6 flex flex-col gap-4 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${c.iconBg}`}>
                  <i className={`${c.icon} ${c.iconColor} text-xl`}></i>
                </div>
                <span className={`text-white text-xs font-bold px-2.5 py-1 rounded-full ${c.badgeColor}`}>{c.badge}</span>
              </div>
              <div>
                <h3 className="font-extrabold text-white text-lg mb-1 group-hover:text-amber-400 transition-colors">{c.label}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{c.description}</p>
              </div>
              <div className="flex items-center gap-1 text-amber-400 text-sm font-semibold mt-auto">
                Shop Collection
                <div className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Trust strip */}
        <div className="border-t border-gray-800 pt-10 grid grid-cols-2 md:grid-cols-4 gap-6 text-center mb-10">
          {[
            { icon: "ri-shield-star-line", label: "Authorized Dealer" },
            { icon: "ri-verified-badge-line", label: "Manufacturer Warranties" },
            { icon: "ri-customer-service-2-line", label: "Real Human Support" },
            { icon: "ri-truck-line", label: "Free Shipping Available" },
          ].map((t) => (
            <div key={t.label} className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-500/10 rounded-xl">
                <i className={`${t.icon} text-amber-400 text-xl`}></i>
              </div>
              <p className="text-gray-400 text-sm font-medium">{t.label}</p>
            </div>
          ))}
        </div>

        {/* Phone CTA */}
        <div className="bg-gray-800 rounded-2xl border border-gray-700 px-6 py-7 flex flex-col md:flex-row items-center justify-between gap-5">
          <div>
            <p className="font-extrabold text-white text-lg mb-1">Not sure which system to get?</p>
            <p className="text-gray-400 text-sm">Our team knows every product we sell. Call us and we&apos;ll help you find the right fit — no pressure, no upselling.</p>
          </div>
          <div className="flex flex-wrap gap-3 shrink-0">
            <a
              href="tel:8666054975"
              className="flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-white font-bold px-6 py-3 rounded-xl text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm"></i>
              </div>
              (866) 605-4975
            </a>
            <a
              href="https://ironhavensupply.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 border border-gray-600 hover:border-amber-400 text-gray-300 hover:text-amber-400 font-bold px-6 py-3 rounded-xl text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              Browse All Products
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
